import "./index.css";     // ✔ CORRECTO
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const originalClear = localStorage.clear;
localStorage.clear = function() {
  console.warn("⚠️ Una extensión intentó limpiar localStorage. BLOQUEADO.");
  // NO ejecutar el borrado
};


reportWebVitals();
